module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-417810ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 125
// module chunks = 1